(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1837],{

/***/ 29133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-cases",
      function () {
        return __webpack_require__(14431);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ new_cases; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/PageHeadingSection.tsx
var PageHeadingSection = __webpack_require__(29016);
// EXTERNAL MODULE: ./components/cards/CaseCard.tsx
var CaseCard = __webpack_require__(65558);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/forms/NewCaseForm.tsx
var NewCaseForm = __webpack_require__(62967);
// EXTERNAL MODULE: ./features/thunks.ts
var thunks = __webpack_require__(32132);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(46035);
// EXTERNAL MODULE: ./components/ui/dialog.tsx
var dialog = __webpack_require__(70499);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
// EXTERNAL MODULE: ./util/auth.tsx + 1 modules
var util_auth = __webpack_require__(19475);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(1438);
// EXTERNAL MODULE: ./components/ui/alert-dialog.tsx
var alert_dialog = __webpack_require__(52508);
;// CONCATENATED MODULE: ./components/CreateCaseModal.tsx











var CreateCaseModal = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), open = ref[0], setOpen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showConfirmation = ref1[0], setShowConfirmation = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,util_auth/* useAuth */.aC)();
    var formId = react.useId();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: function(isOpen) {
            if (!isOpen) {
                setShowConfirmation(true);
                return;
            }
            setOpen(isOpen);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTrigger */.hg, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                    disabled: !auth.isIncludedInSubscription(constants/* PaymentPlanFeatures.add_cases */.TC.add_cases),
                    children: "Add new case"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogContent */.cZ, {
                className: "sm:max-w-[425px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogHeader */.fK, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogTitle */.$N, {
                            children: "New case"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid gap-4 py-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCaseForm/* NewCaseForm */.n, {
                            formId: formId,
                            onSubmit: function(values) {
                                dispatch((0,thunks/* createNewCase */.G2)({
                                    title: values.case_name,
                                    content: values.case_description,
                                    key_question: values.key_question,
                                    is_anonymous: values.is_anonymous
                                })).then(function() {
                                    setOpen(false);
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* DialogFooter */.cN, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialog */.aR, {
                                open: showConfirmation,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogTrigger */.vW, {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                            type: "button",
                                            variant: "destructive",
                                            onClick: function() {
                                                setShowConfirmation(true);
                                            },
                                            children: "Cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogContent */._T, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogHeader */.fY, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogTitle */.f$, {
                                                        children: "Quit editing?"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogDescription */.yT, {
                                                        children: "Changes you made so far will not be saved."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dialog/* AlertDialogFooter */.xo, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogCancel */.le, {
                                                        onClick: function() {
                                                            setShowConfirmation(false);
                                                        },
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dialog/* AlertDialogAction */.OL, {
                                                        onClick: function() {
                                                            setOpen(false);
                                                            setShowConfirmation(false);
                                                        },
                                                        children: "Continue"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                type: "submit",
                                form: formId,
                                children: "Submit"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CreateCaseModal = (CreateCaseModal);

// EXTERNAL MODULE: ./features/casesSlice.ts
var casesSlice = __webpack_require__(94916);
// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./util/hooks/usePagination.tsx
var usePagination = __webpack_require__(10527);
// EXTERNAL MODULE: ./components/ListCta.tsx
var ListCta = __webpack_require__(79992);
;// CONCATENATED MODULE: ./pages/new-cases.tsx













var newCasesSelector = (0,casesSlice/* makeGetCaseByStatus */.uU)({
    selectedStatus: [
        constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED,
        constants/* CaseStatuses.NEW */.HM.NEW
    ],
    sortKey: "created",
    sortOrder: "desc"
});
function NewCases(props) {
    var auth = (0,util_auth/* useAuth */.aC)();
    var _content = props.content, content = _content === void 0 ? {} : _content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: content.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 mb-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeadingSection/* default */.Z, {
                            backgroundImage: content.heading_background,
                            title: content.heading_title,
                            subtitle: content.heading_subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-4",
                            children: [
                                auth.isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center justify-end z-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CreateCaseModal, {})
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CasesList, {
                                        statuses: [
                                            constants/* CaseStatuses.SCHEDULED */.HM.SCHEDULED,
                                            constants/* CaseStatuses.NEW */.HM.NEW
                                        ],
                                        orderBy: "created"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCta/* ListCta */.k, {
                                className: "bg-teal-400",
                                imgSrc: "/media/2023/man.svg",
                                imgWidth: 301,
                                imgHeight: 288,
                                items: [
                                    {
                                        title: "More to Explore",
                                        text: "",
                                        image: "",
                                        list: [
                                            {
                                                text: "Solving real-life challenges"
                                            },
                                            {
                                                text: "Practicing leadership tools"
                                            },
                                            {
                                                text: "Leaders from different cultures"
                                            },
                                            {
                                                text: "1,5-hour sessions"
                                            }, 
                                        ]
                                    },
                                    {
                                        title: "More to Explore",
                                        text: "",
                                        image: "",
                                        list: [
                                            {
                                                text: "Professional executive coaches"
                                            },
                                            {
                                                text: "Experienced mentors"
                                            },
                                            {
                                                text: "Personal support and guidance"
                                            },
                                            {
                                                text: "Preparing for promotion"
                                            }, 
                                        ]
                                    }
                                ],
                                imagePosition: ListCta/* ImagePosition.Right */.O.Right
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var CasesList = function(param) {
    var statuses = param.statuses, orderBy = param.orderBy;
    var cases = (0,es/* useSelector */.v9)(newCasesSelector);
    var ref = (0,usePagination/* usePagination */.h)({
        initialPageSize: 8,
        pageSize: 9,
        statuses: statuses,
        orderBy: orderBy
    }), fetchNextPage = ref.fetchNextPage, itemsLeft = ref.itemsLeft, hasNextPage = ref.hasNextPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4",
                children: cases.map(function(param) {
                    var id = param.id;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseCard/* default */.Z, {
                        caseId: id
                    }, id);
                })
            }),
            hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-6 grid items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_button/* Button */.z, {
                    onClick: function() {
                        return fetchNextPage();
                    },
                    variant: "ghost",
                    children: [
                        "Load more cases (",
                        itemsLeft,
                        ")"
                    ]
                })
            }) : null
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var new_cases = (NewCases);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7763,2722,6445,4814,9078,9774,2888,179], function() { return __webpack_exec__(29133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);